import { useState, useEffect } from 'react';
import api from './api';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';

const STATUSES = ['todo', 'in_progress', 'ready', 'gig_ready'];
const LABELS = {
    todo: 'To Do',
    in_progress: 'In Progress',
    ready: 'Ready',
    gig_ready: 'Gig Ready',
};

export function Songs() {
    const navigate = useNavigate();
    const [songs, setSongs] = useState([]);
    const [newTitle, setNewTitle] = useState('');
    const [newArtist, setNewArtist] = useState('');
    const [newNote, setNewNote] = useState('');
    const { user } = useAuth();
    const isAdmin = user?.role === 'admin';

    const load = () => {
        api.get('/songs').then((res) => setSongs(res.data));
    };

    useEffect(() => { load(); }, []);

    const addSong = async (e) => {
        e.preventDefault();
        if (!newTitle) return;
        await api.post('/songs', { title: newTitle, artist: newArtist, notes: newNote });
        setNewTitle('');
        setNewArtist('');
        setNewNote('');
        load();
    };

    const moveSong = async (id, newStatus) => {
        await api.put(`/songs/${id}`, { status: newStatus });
        load();
    };

    const deleteSong = async (id) => {
        await api.delete(`/songs/${id}`);
        load();
    };

    return (
        <div className="songs-page">
            <h2>Songs</h2>
            {isAdmin && (
                <form onSubmit={addSong} className="add-song-form">
                    <input placeholder="Title" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} />
                    <input placeholder="Writer" value={newArtist} onChange={(e) => setNewArtist(e.target.value)} />
                    <input placeholder="Notes" value={newNote} onChange={(e) => setNewNote(e.target.value)} />
                    <button type="submit">Add Song</button>
                </form>
            )}
            <div className="kanban-board">
                {STATUSES.map((status) => (
                    <div key={status} className="kanban-column">
                        <h3>{LABELS[status]}</h3>
                        {songs.filter((s) => s.status === status).map((song) => (
                            <div key={song.id} className="kanban-card">
                                <strong>{song.title}</strong>
                                {song.artist && <div className="song-artist">{song.artist}</div>}
                                {isAdmin && (
                                    <div className="kanban-card-actions">
                                        <select
                                            value={song.status}
                                            onChange={(e) => moveSong(song.id, e.target.value)}
                                        >
                                            {STATUSES.map((s) => (
                                                <option key={s} value={s}>{LABELS[s]}</option>
                                            ))}
                                        </select>
                                        <button onClick={() => deleteSong(song.id)}>Delete</button>
                                    </div>
                                )}
                                <button className="notes-btn" onClick={() => navigate(`/songs/${song.id}/notes`)}>Notes</button>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
